import { URL } from "~/components/blocks/layout/global-navi/const/url";
import { PATHS } from "~/const/paths";
import { G_ServicePlan } from "~/lib/graphql";

export const LINK_TYPE = {
  /** DmmTV内のリンク */
  DMM_TV_LINK: "dmm-tv-link",
  /** PF側のリンク */
  PF_LINK: "platform-link",
  /** リダイレクト */
  REDIRECT: "redirect",
} as const;

const REQUEST_PATHS = {
  prd: "https://support.dmm.com/dmm-tv/article/47590",
  stg: "https://preview.support.dmm.com/dmm-tv/article/47590",
  lab: "https://preview.support.dmm.com/dmm-tv/article/47590",
  dev: "https://preview.support.dmm.com/dmm-tv/article/47590",
  local: "https://preview.support.dmm.com/dmm-tv/article/47590",
} as const;

export const USER_TYPES = {
  GUEST: "GUEST",
  FREE: "FREE",
  PREMIUM: "PREMIUM",
} as const;

export const USER_MENUS = {
  /** ゲストユーザー */
  [USER_TYPES.GUEST]: {
    servicePlan: G_ServicePlan.Free,
    menus: [
      {
        type: LINK_TYPE.PF_LINK,
        title: "DMMアカウント情報",
        url: process.env.NEXT_PUBLIC_ACCOUNTS_ENDPOINT,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "対応デバイス",
        url: REQUEST_PATHS[process.env.BUILD_MODE],
      },
      {
        type: LINK_TYPE.DMM_TV_LINK,
        title: "お知らせ",
        url: PATHS.NOTIFICATIONS,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "ヘルプ",
        url: "https://support.dmm.com/",
      },
    ],
  },
  /** 会員 & プリープラン */
  [USER_TYPES.FREE]: {
    servicePlan: G_ServicePlan.Free,
    menus: [
      {
        type: LINK_TYPE.PF_LINK,
        title: "DMMアカウント情報",
        url: process.env.NEXT_PUBLIC_ACCOUNTS_ENDPOINT,
      },
      {
        type: LINK_TYPE.DMM_TV_LINK,
        title: "プロフィール管理",
        url: PATHS.PROFILE,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "メールマガジン",
        url: process.env.NEXT_PUBLIC_MAIL_INFORMATION_ENDPOINT,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "対応デバイス",
        url: REQUEST_PATHS[process.env.BUILD_MODE],
      },
      {
        type: LINK_TYPE.DMM_TV_LINK,
        title: "お知らせ",
        url: PATHS.NOTIFICATIONS,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "ヘルプ",
        url: "https://support.dmm.com/",
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "お問い合わせ",
        url:
          process.env.BUILD_MODE === "prd"
            ? "https://support.dmm.com/dmm-tv/contact/475"
            : "https://preview.support.dmm.com/dmm-tv/contact/475",
      },
      {
        type: LINK_TYPE.REDIRECT,
        title: "ログアウト",
        url: URL.logout,
      },
    ],
  },
  [USER_TYPES.PREMIUM]: {
    servicePlan: G_ServicePlan.Premium,
    menus: [
      {
        type: LINK_TYPE.PF_LINK,
        title: "DMMアカウント情報",
        url: process.env.NEXT_PUBLIC_ACCOUNTS_ENDPOINT,
      },
      {
        type: LINK_TYPE.DMM_TV_LINK,
        title: "プロフィール管理",
        url: PATHS.PROFILE,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "メールマガジン",
        url: process.env.NEXT_PUBLIC_MAIL_INFORMATION_ENDPOINT,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "対応デバイス",
        url: REQUEST_PATHS[process.env.BUILD_MODE],
      },
      {
        type: LINK_TYPE.DMM_TV_LINK,
        title: "お知らせ",
        url: PATHS.NOTIFICATIONS,
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "ヘルプ",
        url: "https://support.dmm.com/",
      },
      {
        type: LINK_TYPE.PF_LINK,
        title: "お問い合わせ",
        url:
          process.env.BUILD_MODE === "prd"
            ? "https://support.dmm.com/dmm-tv/contact/475"
            : "https://preview.support.dmm.com/dmm-tv/contact/475",
      },
      {
        type: LINK_TYPE.REDIRECT,
        title: "ログアウト",
        url: URL.logout,
      },
    ],
  },
} as const;

export type UserMenusType = keyof typeof USER_MENUS;
